export const verifyOtpModalTheme = {
  error: 'palette.error.60',
};
